/**
 * Canonical ink channel codes and metadata — mirror of server/src/lib/channels.js.
 * Kept duplicated for now (KISS). If divergence becomes painful, extract to a
 * shared workspace package.
 */
export const CHANNELS = {
  c:  { code: 'c',  label: 'Cyan',     color: '#00B4D8' },
  m:  { code: 'm',  label: 'Magenta',  color: '#E63B7A' },
  y:  { code: 'y',  label: 'Yellow',   color: '#F4C430' },
  k:  { code: 'k',  label: 'Black',    color: '#F5EEDC' },
  o:  { code: 'o',  label: 'Orange',   color: '#FF8A4C' },
  g:  { code: 'g',  label: 'Green',    color: '#7BD4A8' },
  w:  { code: 'w',  label: 'White',    color: '#FAFBFC' },
  mt: { code: 'mt', label: 'Metallic', color: '#B5A87A' },
  v:  { code: 'v',  label: 'Violet',   color: '#7B4DCC' },
};

export const CHANNEL_CODES = Object.keys(CHANNELS);

export const isValidChannel = (code) => Object.hasOwn(CHANNELS, code);

// Core channels (c/m/y/k/o/g) concatenate tightly in canonical order for any
// subset present (['k'] -> "K", cmyk+o -> "CMYKO"); anything else (w, mt, v)
// is a distinct "extra" and gets " + "-joined on.
const CORE_ORDER = ['c', 'm', 'y', 'k', 'o', 'g'];

export const formatChannels = (channels) => {
  if (!Array.isArray(channels) || channels.length === 0) return '';
  const coreLabel = CORE_ORDER.filter((c) => channels.includes(c)).map((c) => c.toUpperCase()).join('');
  const extras = channels
    .filter((c) => !CORE_ORDER.includes(c) && CHANNELS[c])
    .map((c) => CHANNELS[c].label === 'Metallic' ? 'Mt' : CHANNELS[c].label[0]);
  return [coreLabel, ...extras].filter(Boolean).join(' + ');
};
